var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashFilter1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.706,
    height: 45,
    viewBox: "0 0 98.706 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12480",
    "data-name": "Group 12480",
    transform: "translate(-560.977 175.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40567",
    "data-name": "Path 40567",
    d: "M547.37,287h-79l-3.5-20h18.5v4.5h52.477l2.569-3H561.87S560.37,287,547.37,287Z",
    transform: "translate(97 -418)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40568",
    "data-name": "Path 40568",
    d: "M469.37,267V253.5h23v18",
    transform: "translate(97 -418)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40569",
    "data-name": "Path 40569",
    d: "M474.37,254v-5.5h16v5",
    transform: "translate(97 -418)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40570",
    "data-name": "Path 40570",
    d: "M478.37,249v-5.5h10v5",
    transform: "translate(97 -418)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7168",
    "data-name": "Rectangle 7168",
    width: 15,
    height: 6,
    transform: "translate(600.37 -152.5)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7169",
    "data-name": "Rectangle 7169",
    width: 15,
    height: 6,
    transform: "translate(615.37 -152.5)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40571",
    "data-name": "Path 40571",
    d: "M548.37,269v-3.5h-15v6",
    transform: "translate(97 -418)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7170",
    "data-name": "Rectangle 7170",
    width: 15,
    height: 6,
    transform: "translate(600.37 -158.5)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7171",
    "data-name": "Rectangle 7171",
    width: 15,
    height: 6,
    transform: "translate(615.37 -158.5)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7172",
    "data-name": "Rectangle 7172",
    width: 15,
    height: 6,
    transform: "translate(630.37 -158.5)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7173",
    "data-name": "Rectangle 7173",
    width: 15,
    height: 6,
    transform: "translate(600.37 -164.5)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7174",
    "data-name": "Rectangle 7174",
    width: 15,
    height: 6,
    transform: "translate(615.37 -164.5)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7175",
    "data-name": "Rectangle 7175",
    width: 15,
    height: 6,
    transform: "translate(630.37 -164.5)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashFilter1);
export default __webpack_public_path__ + "static/media/dash-filter-1.9c3ab7e49ad0be5f432148fc611896fa.svg";
export { ForwardRef as ReactComponent };